export default __webpack_public_path__ + "02bcf7c2d46384d60961cf212c4696f37c61a3c0a2b68c82f7024ea34d257cb1.svg";